import styled from 'styled-components';

import { Flex } from '@/components/base';
import { MainText } from '@/components/Typography/NamedTypo';
import useColor from '@/hooks/domain/useColor';

import TooltipV2 from '../Tooltip/TooltipV2';
import type { BaseLabelProps } from './BaseLabelTypes';

const BaseLabel = (props: BaseLabelProps) => {
  const color = useColor();
  return (
    <TooltipV2 tooltipNode={props.tooltip}>
      <Style g={4} onClick={props.onClick}>
        <Dot
          style={{
            backgroundColor: props.color || color.profile[11],
            marginTop: 4,
          }}
        />
        <MainText style={{ flex: 1 }}>{props.name}</MainText>
      </Style>
    </TooltipV2>
  );
};

const Style = styled(Flex)``;

const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 6px;
`;

export default BaseLabel;
